import React, { useState, useEffect } from "react";
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(...registerables);
Chart.register(ChartDataLabels);

const LineChart = ({
  type,
  datasets,
  labels,
  maxHeight,
  options,
  id
}) => {
  const [initCompleted, setInitCompleted] = useState(false)
  const [ctx, setCtx] = useState(null)
  const [myChart, setChart] = useState(null)

  const updateChart = () => {
    if (myChart)
      myChart.destroy();

    if (ctx)
      setChart(
        new Chart(ctx, {
          type: type ? type : 'line',
          data: {
            labels: [].concat(...labels),
            datasets: datasets
          },
          options: options ? options : {
            scales: {
              y: {
                beginAtZero: true
              }
            },
            plugins: {
              legend: {
                display: false
              },
              datalabels: {
                display: false
              }
            }
          }
        })
      )
  }

  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true);
      setCtx(document.getElementById(id ? id : "myChart").getContext('2d'))
    }
  }, []);


  useEffect(() => {
    updateChart()
  }, [ctx, datasets])


  return (
    <div className="h-100">
      <canvas id={id ? id : "myChart"} className="w-100" style={{ maxHeight: maxHeight ? maxHeight : 'auto' }} />
    </div>
  );
}

export default LineChart;

